<script setup lang="ts">
import type { PageStoryblok } from "#storyblok-components";

const { blok } = defineProps<{ blok: PageStoryblok }>();

const delayedBlokLoaded = useDelayClientLoad(300);
const blokBodyWithLazyOptions = computed(() => {
  return blok.body?.map((blokInPage) => {
    // Add a few blocks to be only hydrated when visible.
    // We ensure these blocks are already rendered on the server.
    const blokShouldHydrateOnVisible = [
      "product-slider",
      "news-articles",
      "slider",
      "trust-pilot",
    ].includes(blokInPage.component);

    if (blokShouldHydrateOnVisible) {
      return {
        ...blokInPage,
        lazyHydration: "visible",
      };
    }

    const blokShouldHydrateAfter = ["hero-slider"].includes(
      blokInPage.component,
    );

    if (blokShouldHydrateAfter) {
      return {
        ...blokInPage,
        lazyHydration: "delay",
      };
    }

    return {
      ...blokInPage,
      lazyHydration: "idle",
    };
  });
});
</script>

<template>
  <div v-editable="blok">
    <h1
      v-if="blok.hiddenH1"
      class="sr-only"
    >
      {{ blok.hiddenH1 }}
    </h1>

    <template
      v-for="blokInPage in blokBodyWithLazyOptions"
      :key="blokInPage._uid"
    >
      <LazyVisibleBlok
        v-if="blokInPage.lazyHydration === 'visible'"
        :blok="blokInPage"
        :hydrate-on-visible="true"
      />
      <LazyIfBlok
        v-else-if="blokInPage.lazyHydration === 'after'"
        :blok="blokInPage"
        :hydrate-when="delayedBlokLoaded"
      />
      <Blok
        v-else
        :blok="blokInPage"
      />
    </template>
  </div>
</template>
